<footer>
	<!-- <div class="imgArea">
		<div class="imgBox">
			<img
				src="/assets/images/footer-logo.png"
				alt=""
				width="100%"
			/>
		</div>
	</div> -->
	<div class="bottomArea">
		<div class="imgBox">
			<div class="contactBox">
				<h3>聯繫資訊</h3>
				<p>電子郵件：bigaunt666@gmail.com</p>
				<img
					src="/bigaunt/assets/images/line-logo.png"
					alt=""
					style="cursor: pointer; width: 50px; height: 50px"
					(click)="openLineLink()"
				/>
				<img
					src="/bigaunt/assets/images/ig-logo.png"
					alt=""
					style="cursor: pointer; width: 60px; height: 60px"
					(click)="openIgLink()"
				/>
			</div>
			<div class="contactBox">
				<h3>匯款資訊</h3>
				<p>(台新銀行) 812</p>
				<p>28881022569059</p>
			</div>
		</div>
	</div>
</footer>
